import { createFileRoute } from "@tanstack/react-router";

import PlaidOAuthCallback from "@/shared/components/payment-methods/PlaidOAuthCallback";

export const Route = createFileRoute("/_authenticated/settings/payment-methods/callback")({
  component: PlaidOAuthCallback,
  context: () => ({ permissions: "settings.payment-methods" }),
});
